import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    EventRowLoader,
    EventsLoader,
    FirstLineLoader,
    SecondLineLoader,
    ThirdLineLoader,
    SelectionLoader,
    SelectionsWrapper,
    Wrapper,
} from 'src/domains/layouts/shared/loaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const EventLoader = observer('EventLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant, selectionVariant } = configState.componentVariants;
    const selections = [];

    for (let i = 0; i < 3; i++) {
        selections.push(
            <SelectionLoader
                key={i}
                variant={selectionVariant}
            />
        );
    }
    return (
        <Wrapper variant={sportsbookVariant}>
            <EventsLoader>
                <EventRowLoader variant={sportsbookVariant}>
                    <FirstLineLoader />
                    <SecondLineLoader />
                    <ThirdLineLoader />
                </EventRowLoader>
            </EventsLoader>
            <SelectionsWrapper variant={sportsbookVariant}>{selections}</SelectionsWrapper>
        </Wrapper>
    );
});
